export const OK_LEVEL_STATUS_STRING = "Normal";
export const CRITICAL_LEVEL_STATUS_STRING = "Crítico";
export const ALERT_LEVEL_STATUS_STRING = "Alerta";

export type installationLevelStatusString =
  | typeof OK_LEVEL_STATUS_STRING
  | typeof CRITICAL_LEVEL_STATUS_STRING
  | typeof ALERT_LEVEL_STATUS_STRING;

export const OK_LEVEL_STATUS = "normal";
export const CRITICAL_LEVEL_STATUS = "critico";
export const ALERT_LEVEL_STATUS = "alerta";

export type installationLevelStatus =
  | typeof OK_LEVEL_STATUS
  | typeof CRITICAL_LEVEL_STATUS
  | typeof ALERT_LEVEL_STATUS;

export const INSTALLATION_LEVEL_STATUS_TYPES = [
  OK_LEVEL_STATUS,
  ALERT_LEVEL_STATUS,
  CRITICAL_LEVEL_STATUS,
] as const;
export type levelStatus = typeof INSTALLATION_LEVEL_STATUS_TYPES[number];

export const INSTALLATION_LEVEL_STATUS_MAP: Record<levelStatus, installationLevelStatusString> = {
  normal: "Normal",
  alerta: "Alerta",
  critico: "Crítico",
};

export type tankLevelStatus = typeof OK_LEVEL_STATUS | typeof CRITICAL_LEVEL_STATUS;
